export default __webpack_public_path__ + "static/media/home-cafe-slider-img01.b3c0e83c.jpg";